<script setup lang="ts">
import { ref, onMounted } from "vue";
import { Item } from "../../../../types/models";
import { api } from "../../../../api/Api";
import Toast from "../../../../services/Toast";
import { formatNumber } from "../../../../utils/CommonFunctions";
import AsyncImage from "../../../../components/ui/form/AsyncImage.vue";
import IconComponent from "../../../../components/ui/common/IconComponent.vue";

const props = defineProps<{
  warehouses_id?: number | string | null | undefined;
  price_lists_id?: number | string;
}>();

const productList = ref<Item[] | []>([]);

async function getProductList() {
  const params = {
    search_query: code.value,
    price_lists_id: props.price_lists_id ?? 1,
    warehouses_id: props.warehouses_id ?? 1,
  };
  const response = await api.post(
    "inventory/item-management/items/search",
    params
  );
  if (response.success == true) {
    productList.value = response.data;
  } else {
    Toast.show("No Items found", "warning");
  }
}

const code = ref("");
onMounted(() => {
});
</script>

<template>
  <div class="flex-1 overflow-y-auto">
    
    <div class="p-2 bg-white dark:bg-gray-800 min-h-screen">
      <div class="flex-1 max-w-md relative" id="table-search">
        <IconComponent
          name="Search"
          class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
        />
        <input
          type="text"
          v-model="code"
          @keyup.enter="getProductList"
          placeholder="Type and Press Enter ..."
          class="w-full pl-10 pr-10 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400"
        />
        <button
          v-if="code"
          @mouseenter="code = ''"
          @focus="code = ''"
          class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 focus:outline-none"
        >
          <IconComponent name="Trash2" class="w-4 h-4" />
        </button>
    </div>
      <div
        class="mt-6 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2"
      >
        <template v-for="product in productList" :key="product.code">
          <div
            :id="'product-box-' + product.code"
            class="relative cursor-pointer bg-white dark:bg-gray-800 shadow-md rounded-lg p-4 border border-gray-300 dark:border-gray-700 hover:shadow-lg transition-all"
          >
            <!-- Product Image -->
            <div
              class="w-full flex items-center justify-center overflow-hidden mb-1 relative"
            >
              <AsyncImage
                :src="product.photo"
                :alt="product.name"
                class-name="w-[50px]"
              />
            </div>

            <!-- Product Info -->
            <h3 class="text-md font-semibold text-gray-800 dark:text-white">
              {{ product.name }}
            </h3>
            <div class="flex justify-between items-center">
              <p class="text-gray-500 dark:text-gray-400 text-sm flex-grow">
                Code: {{ product.code }}
              </p>
            </div>
            <div
              class="flex justify-between text-sm text-gray-700 dark:text-gray-300"
            >
              <span class="font-bold">{{ formatNumber(product.price) }}</span>
            </div>

            <!-- Prices -->
            <div
              class="mt-2"
              v-if="
                (product.packing_prices ?? []).filter(
                  (e) => e.price_lists_id == props.price_lists_id
                ).length > 0
              "
            >
              <div
                v-for="price in product.packing_prices
                  ?.filter((e) => e.price_lists_id == props.price_lists_id)
                  .splice(0, 2)"
                :key="price.uid"
                class="flex justify-between text-sm text-gray-700 dark:text-gray-300"
              >
                <span
                  >{{ price.unit_of_measure }} x {{ price.inventory_qty }}</span
                >
                <span class="font-bold">{{
                  formatNumber(price.selling_price)
                }}</span>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
